// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__t8Uy1","page":"Layout_page__2Cg8s"};